import { ChecklistStatus } from '../../common/DocPage.types';

export const KeytipStatus = {
  keyboardAccessibilitySupport: ChecklistStatus.unknown,
  markupSupport: ChecklistStatus.unknown,
  highContrastSupport: ChecklistStatus.unknown,
  rtlSupport: ChecklistStatus.unknown,
  testCoverage: ChecklistStatus.unknown
};
